import React from 'react';
import PropTypes from 'prop-types';
import {
	Grid,
	makeStyles
} from '@material-ui/core';

const styles = makeStyles(theme => ({
	fieldRow: {
		width: "100%",

		// expected last one to be button / row of buttons
		'&:last-child': {
			marginTop: theme.spacing(3),
			marginBottom: theme.spacing(4)
		},
	},
}));

function StandardFormLayout(props) {
	const classes = styles();
	const handleKeyPress = (event) => {
		// This prevents form submission on hitting the "enter/return" key
		// Add the prop "submitOnKeyPress" to override
		if (event.charCode === 13 && !props.submitOnKeyPress) {
			event.preventDefault();
		}
	};

	let {children} = props,
		fullChildren = [],
		filteredChildren;

	children.map((rowContent) => {
		if (Array.isArray(rowContent)) {
			rowContent.map((rowChild) => {
				return (
					fullChildren.push(rowChild)
				);
			});
		}

		return (
			fullChildren.push(rowContent)
		);
	});

	filteredChildren = fullChildren.filter(child => !Array.isArray(child));

	return (
		<Grid container direction="column" alignItems="center" onKeyPress={handleKeyPress}>
			{filteredChildren.map((rowContent) => {
				if (rowContent) {
					let key = "stdfrm_" + (rowContent.props.id || rowContent.props.name || rowContent.props.formKey);
					return (
						<Grid key={key} item className={classes.fieldRow}>
							{rowContent}
						</Grid>
					);
				}
				return null;
			})}
		</Grid>
	);
}

StandardFormLayout.propTypes = {
	children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
	submitOnKeyPress: PropTypes.bool
};

export default StandardFormLayout;
